import * as React from 'react';
import { cn } from '@wayste/shadcn/lib/utils';

function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
    return (
        <textarea
            data-slot="textarea"
            className={cn(
                'border-border-default placeholder:text-text-tertiary focus-visible:border-border-focus focus-visible:ring-border-focus/50 aria-invalid:ring-destructive-default/20 aria-invalid:border-destructive-default field-sizing-content shadow-xs flex min-h-16 w-full rounded-md border bg-transparent px-3 py-2 text-base outline-none transition-[color,box-shadow] focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
                className,
            )}
            {...props}
        />
    );
}

export { Textarea };
